import MentorForm from '@/components/mentor/MentorForm';
import { useTranslation } from '@/config/i18n';
import PATH from '@/routes/path';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const MentorManagementNewPage: React.FC = () => {
  const [t] = useTranslation('');
  const navigate = useNavigate();

  return (
    <>
      <div className="header-top">
        <h2 className='title flex'>
          <span className='pi pi-arrow-left text-[20px] text-gray-500 cursor-pointer' onClick={() => navigate(PATH.mentor_management)}></span>
          <span className='ml-3'>
            {t('user.new_mentor')}
          </span>
        </h2>
      </div>
      <MentorForm />
    </>
  )
}

export default MentorManagementNewPage;
